import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
    connect() {
        this.carousel = null;
        this.ctner = this.element.querySelector('.swiper');
        let config = {
            slidesPerView: "auto",
            spaceBetween: 6,
            freeMode: {
                enabled: true,
                sticky: false,
                momentum: true,
            },
            scrollbar: {
                el: this.element.querySelector(".swiper-scrollbar"),
                draggable: true,
                hide: false,
            },
            observer: true
        };
        this.initCarousel(config);
    }
    initCarousel(config) {
        import(/* webpackChunkName: "swiper" */ 'swiper').then(({Swiper}) => {
            import(/* webpackChunkName: "swiper-modules" */ 'swiper/modules').then(({FreeMode, Scrollbar}) => {
                Swiper.use([FreeMode, Scrollbar]);
                this.carousel = new Swiper(this.ctner, config);
            });
        });
    }
}